import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { useScrollTop } from "../hook/useScrollTop";
import investorImg from "../images/investor.jpg";
import WhyInvest from "../sections/why-invest";

const Investors = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Investor</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={investorImg}>
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 lh-64 mt-4 text-capitalize header-background-image-size">
            Investors
          </h1>
        </div>
      </Header>
      {/* <InvestorHome /> */}
      <div className="ms-47 me-47 pt-7">
        <WhyInvest />

        <hr className="mt-7 pb-7" />

        <section>
          <h2 className="fs-28 lh-30 pb-5 fw-700">
            Leveraging a favourable macro environment
          </h2>
          <ul className="fs-16 text-align-justify lh-30">
            <li>
              AT customers are mainly the large MNOs and other telecoms
              providers, who in turn provide wireless voice and data services to
              end-consumers and businesses.
            </li>
            <li>
              Africa and the Middle East have clear and compelling population
              and GDP drivers that are propelling its mobile markets forward
              and, in turn, demand for AT services.
            </li>
            <li>
              In our expected ten markets the UN forecasts population growth of
              41 million over the next five years.
            </li>
            <li>
              The combination of physical vastness, lack of fixed line
              infrastructure, and fast developing economies means that mobile
              infrastructure is already critical to its societies and economies,
              with demand expected to continue to grow.
            </li>
          </ul>
        </section>

        <hr className="mt-7 pb-7" />

        <section className="">
          <h3 className="fs-28 lh-30 fw-700 pb-5">
            With unique strengths and positioning to deliver on long term growth
            opportunities
          </h3>
          <ul className="fs-16 text-align-justify lh-30">
            <li>
              AT have a strong position in all our markets. We are the market
              leader and sole independent player in Tanzania, DRC, Congo
              Brazzaville and Senegal.
            </li>
            <li>
              Independent forecasts estimate 63 million new mobile connections
              (2021 to 2026) in our expected ten markets
            </li>
            <li>
              Independent estimates suggest this will necessitate 25,000 new
              points of service (PoS) – each being a potential new tenancy for
              AT.
            </li>
          </ul>
        </section>

        <hr className="mt-7 pb-7" />

        <section className="">
          <h3 className="fs-28 lh-30 fw-700 pb-5">
            Through multiple activities, building a platform for profitable and
            sustainable growth
          </h3>
          <ul className="fs-16 lh-30 text-align-justify">
            <li>
              Acquire tower portfolios, yielding large long-term contracted
              revenues.
            </li>
            <li>Custom build new tower assets for MNOs (build-to-suit).</li>
            <li>
              Promote tower sharing through multiple MNOs on tower sites
              (colocation), and multiple technologies on tower sites (amendment
              tenancies); delivering cost benefits to customers and reducing
              environmental impact.
            </li>
            <li>
              Operate the tower and associated passive infrastructure, providing
              a full suite of tower-related space, power and operational
              services. These include:
              <ul>
                <li>Site preparation and construction;</li>
                <li>Site management and maintenance;</li>
                <li>Power management;</li>
                <li>Security and other services.</li>
              </ul>
            </li>
            <li>
              Additionally, AT is developing ancillary products and services in
              fibre backhaul, localised small cell and in-building solutions and
              data centre services; for potential rollout across the Group.
            </li>
          </ul>
        </section>

        <hr className="mt-7 pb-7" />

        <section className="">
          <h3 className="fs-28 lh-30 fw-700 pb-5">
            Embedding business excellence in the platform
          </h3>
          <ul className="fs-16 text-align-justify lh-30">
            <li>Continually improving operational leverage and performance.</li>
            <li>High customer service levels.</li>
            <li>
              Supply chain optimisation driving efficiencies across the business
              (“One team, one business”).
            </li>
            <li>
              Realised capex savings through reduction in strategic suppliers.
            </li>
          </ul>
          <div className="row my-3 g-5">
            <div className="col-12 col-sm-6 col-md-4 text-danger">
              <h3 className="fs-38 ">99.99%</h3>
              <p className="fs-16 gilroy-bold">
                power uptime across all our towers over 2021
              </p>
            </div>
            <div className="col-12 col-sm-6 col-md-4 text-danger">
              <h3 className="fs-38 ">97%</h3>
              <p className="fs-16 gilroy-bold">
                in operating companies are local employees
              </p>
            </div>
            <div className="col-12 col-sm-6 col-md-4 text-danger">
              <h3 className="fs-38 ">31%</h3>
              <p className="fs-16 gilroy-bold">
                of employees trained in Lean Six Sigma (Orange or Black belt) by
                the end of 2021
              </p>
            </div>
          </div>
        </section>

        <hr className="mt-7 pb-7" />

        <section className="">
          <h3 className="fs-28 lh-30 fw-700 pb-5">
            Using a robust business model, delivering financial strength and
            sustainable differentiation
          </h3>
          <ul className="fs-16 text-align-justify lh-30">
            <li>
              Contracts are protected against power prices and general
              inflation.
            </li>
            <li>
              Contracts are long term, with $3.9 billion contracted future
              revenue with 7.6 years of average remaining life.
            </li>
            <li>
              High quality contracts in hard currencies with multinational MNOs,
              delivering committed revenues for many years ahead.
            </li>
            <li>
              Sustainable lease rates and stable and visible cash flows with
              diversified customer base.
            </li>
            <li>Balance sheet strength to continue to support investments.</li>
            <li>
              Funding and financing options provide flexibility to support
              long-term growth initiatives.
            </li>
          </ul>
          <div className="row my-3 g-5">
            <div className="col-12 col-sm-6 col-md-6 text-danger">
              <h3 className="fs-38 ">$3.9B</h3>
              <p className="fs-16 gilroy-bold">Contracted revenues</p>
            </div>
            <div className="col-12 col-sm-6 col-md-6 text-danger">
              <h3 className="fs-38 ">65%</h3>
              <p className="fs-16 gilroy-bold">
                % Adj. EBITDA in USD/EUR pegged
              </p>
            </div>
          </div>
        </section>

        <hr className="mt-7 pb-7" />
      </div>
      <Footer />
    </>
  );
};

export default Investors;
